<!-- <div class="container-fluid"> -->
<!-- <p-menu #menu [model]="items"></p-menu> -->
<!-- </div> -->

<!-- Use nav for navigation topbar (Valid HTML5 semantics) -->
<nav class="topbar" aria-label="Topbar">
    <!-- Skeleton is visible while topbar content is loading -->
    <div *ngIf="showSkeleton" class="skeleton topbar__skeleton">
        <div class="visually-hidden">Topbar is loading...</div>
        <div
            *ngFor="let item of skeletonMenu; let index = index"
            class="skeleton__item"
            [ngClass]="{ 'skeleton__client-item': index === 0 }"
            aria-hidden="true"
        >
            <div class="skeleton__item-background skeleton__image"></div>
            <div class="skeleton__item-background skeleton__label"></div>
        </div>
    </div>

    <ul *ngIf="!showSkeleton" class="topbar__menu menu" [attr.aria-busy]="showSkeleton">
        <li *ngFor="let item of menu; let index = index" class="menu__item" [ngClass]="{ 'menu__client-item': index === 0 }">
            <!-- Use button instead of link (Proper way to make buttons that does not route to another url) -->
            <button *ngIf="index === 0" class="menu__link menu__user-link" (click)="openSubMenu($event)">
                <!-- <span *ngIf="item.badge > 0" class="badge-icon">
                    <span class="badge rounded-pill">{{ item.badge }}</span>
                </span> -->
                <img class="menu__image" src="/assets/img/{{ item.icon }}" alt="" aria-hidden="true" />
                <span class="menu__label">{{ userName }}</span>
            </button>

            <a *ngIf="index !== 0" class="menu__link" routerLink="/{{ item.link }}" tabindex="-1">
                <!-- <span *ngIf="item.badge > 0" class="badge-icon">
                    <span class="badge rounded-pill">{{ item.badge }}</span>
                </span> -->
                <img class="menu__image" src="/assets/img/{{ item.icon }}" alt="" aria-hidden="true" />
                <span class="menu__label">{{ item.label }}</span>
            </a>

            <p-menu *ngIf="index === 0" #menu class="menu__submenu submenu" [model]="submenu" [popup]="true"></p-menu>
        </li>
    </ul>
</nav>
